import liveChatBannerConfig from "../components/LiveChat/AlmeLiveChatBanner/AlmeLiveChatBannerConfig";
import { defaultTenant } from "../components/AlmeTenantSelector/AlmeTenants";
import { defaultLogLevel } from "../Logger";
export const expiredResponseEntryId = '00000000-0000-0000-0000-10000000000';
const defaultConfig = {
    main: {
        apiHostName: "ivadev2.synchronycredit.com",
        isLoggedIn: false,
        appAccessKey: defaultTenant.value,
        showIvaChatIcon: false,
        platform: "UNKNOWN",
    },
    webUrl: "",
    allowedOrigins: [window.location.origin],
    lastEntryIdInterval: 10000,
    header: {
        headerText: 'Sydney - Your Virtual Assistant',
        isMinimizeEnabled: true,
        isCloseEnabled: true,
        isEmailTranscriptEnabled: false,
        liveChatHeaderText: 'Live Chat',
    },
    history: {
        errorResponse: {
            entryId: '00000000-0000-0000-0000-000000000000',
        },
        expiredResponse: {
            entryId: expiredResponseEntryId,
        },
    },
    footer: {
        submitButtonText: 'Send',
        maxInputLength: 200,
        userTypingEventDelay: 10000,
    },
    SystemErrorResponse: 'Please try again later, this service is currently down.',
    expiredErrorResponse: 'Due to inactivity, your session has expired.',
    zIndex: 3000201,
    isMobile: false,
    mobileBreakpoint: 600,
    uiVersion: '1.22.9',
    channel: "Web",
    liveChatControls: {
        buttonText: 'End Live Chat',
        defaultOperatorName: 'Operator',
        typingMessageText: 'is typing',
        typingMessageDelay: 3000,
        dialog: {
            headerText: 'End Live Chat?',
            bodyText: 'Are you sure you want to end the live chat session?',
            buttons: {
                declineButtonText: 'No',
                acceptButtonText: 'Yes',
            },
        },
    },
    liveChatOperatorResponse: {
        useUniqueChatIcons: true,
        openNewIconTitle: "Step Out",
        userCheckStatus: {
            timeoutInSec: 30,
            dialog: {
                headerText: 'Chat will timeout in...',
                bodyText: 'Would you like to continue chatting?',
                buttons: {
                    declineButtonText: 'End Chat',
                    acceptButtonText: 'Continue Chat',
                },
            },
        },
    },
    liveChatUserResponse: {},
    liveChatBanner: liveChatBannerConfig,
    notificationApi: {
        pollForNotifications: false,
        pollForLiveChat: false,
        notificationInterval: 10000,
        liveChatInterval: {
            connected: 2000,
            disconnected: 30000,
        },
    },
    sessionTimeoutInMs: 15 * 60000, // default value overriden on GetConfiguration
    sessionTimeoutWarningPeriodInMs: 2 * 60000,
    UiLogLevel: defaultLogLevel,
    IsEnableUILog: "False",
    languageCode: "EN",
};
export default defaultConfig;
